var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isRouteAllowed)?_c('v-list-item',{staticClass:"pr-0 pl-12",attrs:{"link":"","to":'/reserves-records'}},[_c('v-list-item-content',{staticClass:"py-0"},[_c('v-list-item-title',[_vm._v("Картотека резервов")])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }